module.exports = __webpack_public_path__ + "static/img/bg.16f74252.jpg";